import type { Directive, DirectiveBinding } from 'vue'

interface DecryptOptions {
  text: string
  speed?: number
  delay?: number
}

const CHARS =
  'αβγδεζηθικλμνξοπρστυφχψωアイウエオカキクケコサシスセソタチツテト0123456789!@#$%^&*abcdefghijklmnopqrstuvwxyz'

const cleanups = new WeakMap<HTMLElement, () => void>()

export const decryptText: Directive<HTMLElement, DecryptOptions> = {
  mounted(el: HTMLElement, binding: DirectiveBinding<DecryptOptions>) {
    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const { text: finalText, speed = 45, delay = 2 } = binding.value

    if (reduceMotion) {
      el.textContent = finalText
      return
    }

    const rand = (i: number): string =>
      finalText[i] === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)]

    el.textContent = finalText
    el.style.minWidth = `${el.offsetWidth}px`

    let interval: ReturnType<typeof setInterval> | null = null
    const clear = (): void => {
      if (interval) {
        clearInterval(interval)
        interval = null
      }
    }

    const display = Array.from({ length: finalText.length }, (_, i) => rand(i))
    let idx = 0
    interval = setInterval(() => {
      for (let i = 0; i < delay && idx < finalText.length; i++, idx++) display[idx] = finalText[idx]
      for (let i = idx; i < finalText.length; i++) display[i] = rand(i)
      el.textContent = display.join('')
      if (idx >= finalText.length) clear()
    }, speed)

    cleanups.set(el, clear)
  },
  unmounted(el: HTMLElement) {
    cleanups.get(el)?.()
    cleanups.delete(el)
  },
}
